export * from './simple-layout.component';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/containers/simple-layout/index.ts